export class NoTenantOfProductHttpHeaderError extends Error {
  constructor(public product: string) {
    super();
  }
}
